<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :rules="rules"
    :placeholder="placeholder"
    solo
    flat
    :disabled="disabled"
    :readonly="readonly"
    item-color="cyan"
    hide-details
    v-on:change="emitValue()"
  />
</template>

<script>
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    minDate: {
      type: String,
      default: moment().format("YYYY-MM-DD"),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledStartTime: {
      type: String,
      default: null,
    },
    disabledEndTime: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      this.time = null;
      this.emitValue();
      this.initTimeList();
    },
    disabledStartTime: function () {
      this.initTimeList();
    },
    disabledEndTime: function () {
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
      timeList: [],
    };
  },
  methods: {
    init() {
      let val = this.value;
      if (val === "12:00 AM" && this.type === "end-time") {
        val = "11:59 PM";
        this.$emit("input", val);
        this.$emit("change", val);
      }
      this.time = val;
      if (this.type == "start-time" || this.type == "end-time") {
        if (Array.isArray(this.timeList)) {
          const exists = this.timeList.some((item) => item.value === this.time);
          if (!exists && this.time) {
            this.time = null;
            this.emitValue();
          }
        }
      }
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");

      let minTimeStr = this.minTime;
      if (minTimeStr === "12:00 AM"  && this.type === "end-time") {
        minTimeStr = "11:59 PM";
      }
      let minTime = minTimeStr
        ? moment(`${this.minDate} ${minTimeStr}`, "YYYY-MM-DD hh:mm A")
        : null;

      let disableStart = this.disabledStartTime
        ? moment(
            `${this.minDate} ${this.disabledStartTime}`,
            "YYYY-MM-DD hh:mm A"
          )
        : null;

      let disabledEndStr = this.disabledEndTime;
      if (disabledEndStr === "12:00 AM" && this.type === "end-time") {
        disabledEndStr = "11:59 PM";
      }
      let disableEnd = disabledEndStr
        ? moment(
            `${this.minDate} ${disabledEndStr}`,
            "YYYY-MM-DD hh:mm A"
          )
        : null;

      // Add 12:00 AM as the first option if needed, but keeping existing loop logic:
      while (startTime.isBefore(endTime)) {
        let formattedTime = startTime.add(15, "minutes").format("hh:mm A");
        let isDisabled = false;

        let checkTime =
          formattedTime === "12:00 AM" && this.type === "end-time"
            ? moment(`${this.minDate} 23:59:00`, "YYYY-MM-DD HH:mm:ss")
            : startTime;

        if (minTime && checkTime.isSameOrBefore(minTime)) {
          isDisabled = true;
        }

        if (disableStart && disableEnd) {
          if (
            checkTime.isSameOrAfter(disableStart) &&
            checkTime.isSameOrBefore(disableEnd)
          ) {
            isDisabled = true;
          }
        }

        let text = formattedTime;
        let value = formattedTime === "12:00 AM" && this.type === "end-time" ? "11:59 PM" : formattedTime;

        if (isDisabled) {
          this.timeList.push({ text, value, disabled: true });
        } else {
          this.timeList.push({ text, value, disabled: false });
        }
      }

    },
  },
  created() {
    this.initTimeList();
  },
  mounted() {
    this.init();
  },
};
</script>
